module.exports = __webpack_public_path__ + "static/samurai-da70f6c556d33a0ade6b99cd36609537.svg";